import React from 'react';
import './InfoCard.scss'; // Make sure to create a SASS file with this name

const InfoCard = () => {
  return (
    <div className="info-card">
      <div className="header">Address book reminder</div>
      <div className="content">
      Please ensure that your name is registered on the campus card, and please carefully verify your corresponding name and identity information before performing permission operations.
      </div>
    </div>
  );
};

export default InfoCard;
